import type { MarketExceptionType } from '../../MarketExceptionTypes'
import { Common } from '../Common/Common'

export const HU: MarketExceptionType = {
  ...Common,
  hasNativeCreditCard: true,
  hasStoreCredit: true,
  signUpReCaptcha: true,
  showPasswordRequirements: true,
  signupPrivacyPolicy: {
    enabled: true,
    required: false,
  },
  checkoutTermsAndConditionsAgreementCheckbox: {
    enabled: true,
    required: true,
  },
  currencyCode: 'EUR',
  creditCardProvidersSupported: ['VI', 'MC', 'AX'],
  hasAddressRegion: true,
  supportsStoreCredit: true,
  applePayOTP: true,
  isWorldPay3DS: true,
  hasPaypal3DS: true,
  hasProductAvailability: true,
  tax: {
    inclusive: true,
  },
  hasBankWire: true,
  skuPricingOverrides: [
    '34083',
    '34825',
    '35577',
    '36203',
    '36204',
    '36205',
    '36576',
    '36577',
    '36580',
  ],
}
